import { gql } from '@apollo/client';

export const UPSERT_TEMPLATE_QUESTIONS = gql`
  mutation upsertTemplateQuestions($input: UpsertTemplateQuestionsInput!) {
    template: upsertTemplateQuestions(input: $input) {
      id
    }
  }
`;
